@if(label) {
  <span class="badge" [style]="{'background-color': label.backcolor, 'color': label.textcolor}">{{ label.name }}</span>
}
